import React from 'react';
import ReactDOM from 'react-dom/client';

import './index.css';
import App from './components/App';
import {getSessionTime, resetSessionTime} from './utils/sessionTime';
import Login from './components/Login';

const root = ReactDOM.createRoot(document.getElementById('root'));


if (getSessionTime()) {
  fetch(`/api/doLogin?origin=${window.location.origin}`).then((res) => {
    switch (res.status) {
      case 401:
        window.location.href = `${window.location.origin}/api/login`;
        break;
      case 423:
        resetSessionTime();
        window.location.href = '/';
        break;
      default:
        root.render(
            <React.StrictMode>
              <App/>
            </React.StrictMode>
        );
        break;
    }
  })
} else {
  root.render(
    <React.StrictMode>
      <Login/>
    </React.StrictMode>

  )
}
